import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root'
})
export class PanjaInfoServiceService extends ApiService {


  getPanjaInfo(): Observable<any>{
    return this.get<any>(ROUTES.PANJA_INFO);
  }

  getPanjaRenewalInfo(): Observable<any>{
    return this.get<any>(ROUTES.PANJA_RENEWAL_INFO)
  }
}
